import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'
import type {
  TestCase,
  TestCaseBody
} from '@eggplant/types'

interface Props {
  testCaseId: string
  onError?: () => void
  onSuccess?: (response: TestCase) => void
  params: TestCaseBody
  children?: (data: TestCase) => ReactElement
}

const UpdateModelerScriptTestCaseRequest = ({
  testCaseId,
  onError,
  onSuccess,
  params,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases/scripted/${testCaseId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateModelerScriptTestCaseRequest
